// extracted by mini-css-extract-plugin
export default {"survey-layout--no-bottom-margin":"styles-module_survey-layout--no-bottom-margin---fruEL","header-button":"styles-module_header-button---Jk30M"};